import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import KivaProxy from "@/utils/kivaProxy/src";
export default {
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    saveUncordedLabels: function saveUncordedLabels(id, app, model, labels) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (labels[0]) {
                labels.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(element) {
                    var data;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          data = {
                            record: id,
                            app: app,
                            record_model: model,
                            label: element.label.value
                          };
                          _context.next = 3;
                          return new KivaProxy({
                            endpoint: "system/label_record"
                          }).create(data).then(function (response) {}).catch(function (err) {
                            _this.loading = false;
                          });
                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};